export default __webpack_public_path__ + "static/media/icon-calendar.ab5c6646.svg";